import { z } from "zod";

import { SCHEDULING_METHOD_VARIANTS } from "../constants/schedulingMethods";

const phoneScheduleVariantSchema = z.enum(SCHEDULING_METHOD_VARIANTS, {
  error: "Please select an option",
});

const phoneSchedulingMethodSchema = z.object({
  number: z
    .string()
    .optional()
    .refine(
      (val) => !val || /^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/.test(val),
      {
        message: "Please enter number with format: (123) 456-7890",
      },
    ),
  ext: z.string().optional(),
  variant: z.union([phoneScheduleVariantSchema.optional(), z.literal("")]),
});

export const schedulingMethodSchema = z
  .object({
    phone_number: phoneSchedulingMethodSchema.optional(),
    email: z.string().optional(),
    booking_link: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    const { phone_number, email, booking_link } = data;

    if (phone_number?.number) {
      const phoneRegex = /^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
      if (!phoneRegex.test(phone_number.number)) {
        ctx.addIssue({
          code: "custom",
          message: "Please enter number with format: (123) 456-7890",
          path: ["phone_number.number"],
        });
      }

      if (!phone_number.variant?.trim()) {
        ctx.addIssue({
          code: "custom",
          message: "Please select a preference",
          path: ["phone_number.variant"],
        });
      }
    }

    if (email) {
      if (!z.email().safeParse(email).success) {
        ctx.addIssue({
          code: "custom",
          message: "Must be a valid email address",
          path: ["email"],
        });
      }
    }

    if (booking_link) {
      if (!z.url().safeParse(booking_link).success) {
        ctx.addIssue({
          code: "custom",
          message: "Must be a valid url",
          path: ["booking_link"],
        });
      }
    }
  });
